(function(){(function(){  if(!window.__ROUTER_BASENAME){    var path=window.location.pathname;    var knownRoutes=["/","/backing-calculator","/binding","/binding-length-calculator","/border","/skirt","/cost-estimator","/fabric-converter","/button-converter","/cover-hem-guide","/needle-guide","/precuts-converter","/flying-geese","/quilt-layout"];    var segments=path.split("/").filter(function(s){return s});    var basename="/";    for(var i=0;i<segments.length;i++){      var testPath="/"+segments.slice(i).join("/");      var isKnownRoute=knownRoutes.some(function(r){return testPath===r||testPath===r+"/"});      if(isKnownRoute){        basename=i===0?"/":"/"+segments.slice(0,i).join("/");        break;      }    }    if(basename==="/"&&segments.length>0){      var hasKnownRoute=knownRoutes.some(function(r){return r==="/"});      if(hasKnownRoute){        basename="/"+segments.join("/");      }    }    window.__ROUTER_BASENAME=basename;  }})();(function(){  if(!window.__ROUTER_BASENAME){    var path=window.location.pathname;    var knownRoutes=["/","/backing-calculator","/binding","/binding-length-calculator","/border","/skirt","/cost-estimator","/fabric-converter","/button-converter","/cover-hem-guide","/needle-guide","/precuts-converter","/flying-geese","/quilt-layout"];    var segments=path.split("/").filter(function(s){return s});    var basename="/";    for(var i=0;i<segments.length;i++){      var testPath="/"+segments.slice(i).join("/");      var isKnownRoute=knownRoutes.some(function(r){return testPath===r||testPath===r+"/"});      if(isKnownRoute){        basename=i===0?"/":"/"+segments.slice(0,i).join("/");        break;      }    }    if(basename==="/"&&segments.length>0){      var hasKnownRoute=knownRoutes.some(function(r){return r==="/"});      if(hasKnownRoute){        basename="/"+segments.join("/");      }    }    window.__ROUTER_BASENAME=basename;  }})();(function(){  if(!window.__ROUTER_BASENAME){    var path=window.location.pathname;    var knownRoutes=["/","/backing","/binding","/binding-length-calculator","/border","/skirt","/cost-estimator","/fabric-converter","/button-converter","/cover-hem-guide","/needle-guide","/precuts-converter","/flying-geese","/quilt-layout"];    var segments=path.split("/").filter(function(s){return s});    var basename="/";    for(var i=0;i<segments.length;i++){      var testPath="/"+segments.slice(i).join("/");      var isKnownRoute=knownRoutes.some(function(r){return testPath===r||testPath===r+"/"});      if(isKnownRoute){        basename=i===0?"/":"/"+segments.slice(0,i).join("/");        break;      }    }    if(basename==="/"&&segments.length>0){      var hasKnownRoute=knownRoutes.some(function(r){return r==="/"});      if(hasKnownRoute){        basename="/"+segments.join("/");      }    }    window.__ROUTER_BASENAME=basename;  }})();(function(){  if(!window.__ROUTER_BASENAME){    var path=window.location.pathname;    var knownRoutes=["/","/binding","/binding-length-calculator","/border","/skirt","/cost-estimator","/fabric-converter","/button-converter","/cover-hem-guide","/needle-guide","/precuts-converter","/flying-geese","/quilt-layout"];    var segments=path.split("/").filter(function(s){return s});    var basename="/";    for(var i=0;i<segments.length;i++){      var testPath="/"+segments.slice(i).join("/");      var isKnownRoute=knownRoutes.some(function(r){return testPath===r||testPath===r+"/"});      if(isKnownRoute){        basename=i===0?"/":"/"+segments.slice(0,i).join("/");        break;      }    }    if(basename==="/"&&segments.length>0){      var hasKnownRoute=knownRoutes.some(function(r){return r==="/"});      if(hasKnownRoute){        basename="/"+segments.join("/");      }    }    window.__ROUTER_BASENAME=basename;  }})();(function(){  if(!window.__ROUTER_BASENAME){    var path=window.location.pathname;    var knownRoutes=["/","/binding","/binding-length-calculator","/border","/skirt","/cost-estimator","/fabric-converter","/button-converter","/cover-hem-guide","/needle-guide","/precuts-converter","/flying-geese","/quilt-layout"];    var segments=path.split("/").filter(function(s){return s});    var basename="/";    for(var i=0;i<segments.length;i++){      var testPath="/"+segments.slice(i).join("/");      var isKnownRoute=knownRoutes.some(function(r){return testPath===r||testPath===r+"/"});      if(isKnownRoute){        basename=i===0?"/":"/"+segments.slice(0,i).join("/");        break;      }    }    window.__ROUTER_BASENAME=basename;  }})();(function(){  if(!window.__ROUTER_BASENAME){    var path=window.location.pathname;    var knownRoutes=["/","/binding","/binding-length-calculator","/border","/skirt","/cost-estimator","/fabric-converter","/button-converter","/cover-hem-guide","/needle-guide","/precuts-converter","/flying-geese","/quilt-layout"];    var segments=path.split("/").filter(function(s){return s});    var basename="/";    for(var i=segments.length;i>0;i--){      var testPath="/"+segments.slice(i).join("/");      var match=knownRoutes.some(function(r){return testPath===r||testPath.startsWith(r+"/")});      if(match){        basename="/"+segments.slice(0,i).join("/");        break;      }    }    window.__ROUTER_BASENAME=basename===""?"/":basename;  }})();  if(!window.__ROUTER_BASENAME){    var path=window.location.pathname;    var knownRoutes=["/","/binding","/binding-length-calculator","/border","/skirt","/cost-estimator","/fabric-converter","/button-converter","/cover-hem-guide","/needle-guide","/precuts-converter","/flying-geese","/quilt-layout"];    var segments=path.split("/").filter(function(s){return s});    var basename="/";    for(var i=segments.length;i>0;i--){      var testPath="/"+segments.slice(i).join("/");      var match=knownRoutes.some(function(r){return testPath===r||testPath.startsWith(r+"/")});      if(match){        basename="/"+segments.slice(0,i).join("/");        break;      }    }    window.__ROUTER_BASENAME=basename===""?"/":basename;  }})();class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.allPredictiveSearchInstances =
      document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    super.onChange();
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      // Remove the results when they are no longer relevant for the new search term
      // so they don't show up when the dropdown opens again
      this.querySelector("#predictive-search-results-groups-wrapper")?.remove();
    }

    // Update the term asap, don't wait for the predictive search query to finish loading
    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) {
      event.preventDefault();
      return;
    }
    // Search is navigating to the results page — set the flag that the /search
    // template reads to suppress the Klaviyo signup popup. This setter previously
    // lived only in main-search.liquid, so searches started from any other page
    // (home, collection, product) never set it and the popup fired on every Enter.
    try { sessionStorage.setItem('qsv_suppress_popup', '1'); } catch (e) {}
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = '';
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();

    if (!currentSearchTerm.length) return;

    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up')
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (
      event.code === 'ArrowUp' ||
      event.code === 'ArrowDown'
    ) {
      event.preventDefault();
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector(
      "[data-predictive-search-search-for-text]"
    );
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      let matches;
      try { matches = currentButtonText.match(new RegExp(previousTerm, "g")); } catch (e) { return; }
      if (!matches || matches.length > 1) return;
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');

    // Filter out hidden elements (duplicated page and article resources) thanks
    // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
    const allVisibleElements = Array.from(
      this.querySelectorAll("li, button.predictive-search__item")
    ).filter((element) => element.offsetParent !== null);
    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    this.statusElement.textContent = "";

    if (!moveUp && selectedElement) {
      activeElementIndex =
        selectedElementIndex === allVisibleElements.length - 1
          ? 0
          : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex =
        selectedElementIndex === 0
          ? allVisibleElements.length - 1
          : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedOption = this.querySelector(
      '[aria-selected="true"] a, button[aria-selected="true"]'
    );

    if (selectedOption) selectedOption.click();
  }

  normalizeSearchTerm(term) {
    return term.trim().split(/\s+/).map(function(w) {
      var lower = w.toLowerCase();
      if (/[a-z]/.test(lower) && /[0-9].*[0-9]/.test(lower) && lower.length >= 3 && lower.length <= 16) {
        var normalized = lower.replace(/([a-z])([0-9])/g, '$1 $2').replace(/([0-9])([a-z])/g, '$1 $2');
        // If normalization splits into 3+ tokens, the model number has both letter→digit
        // and digit→letter boundaries (e.g. "pr680w"). Shopify indexed it as one token —
        // keep the original so it matches exactly rather than splitting into fragments.
        if (normalized.split(/\s+/).length > 2) return lower;
        return normalized;
      }
      return w;
    }).join(' ');
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    const apiTerm = this.normalizeSearchTerm(searchTerm);
    this.setLiveRegionLoadingState();

    this.abortController.abort();
    this.abortController = new AbortController();

    // QSV term aliases: shopper terms Shopify's index can't match to the right
    // products. "prostitcher" / "pro stitcher" never match the hyphen-tokenized
    // "Pro-Stitcher" product titles, so rewrite to "pro-stitcher" and render those
    // results directly — the alias is known-correct, so we skip the relevance guard
    // (which would otherwise reject the hyphen mismatch and fall back to noise).
    const QSV_ALIASES = { 'prostitcher': 'pro-stitcher', 'pro stitcher': 'pro-stitcher', 'quilt motion': 'quiltmotion', 'quilt motion x': 'quiltmotion x', 'grace quilt motion': 'grace quiltmotion', 'grace quilt motion x': 'grace quiltmotion x' };
    const aliasTerm = QSV_ALIASES[searchTerm.trim().toLowerCase()];
    if (aliasTerm) {
      const aliasKey = 'qsv-alias:' + aliasTerm;
      if (this.cachedResults[aliasKey]) {
        this.renderSearchResults(this.cachedResults[aliasKey]);
        return;
      }
      fetch(
        `${routes.predictive_search_url}?q=${encodeURIComponent(aliasTerm)}&resources[type]=product,collection,page,query&resources[limit]=10&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,vendor,tag,variants.title&section_id=predictive-search`,
        { signal: this.abortController.signal }
      ).then((r) => r.ok ? r.text() : null)
       .then((t) => {
         if (!t || searchTerm !== this.searchTerm) return;
         const markup = new DOMParser().parseFromString(t, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
         this.allPredictiveSearchInstances.forEach((inst) => { inst.cachedResults[aliasKey] = markup; });
         this.renderSearchResults(markup);
       })
       .catch(() => {});
      return;
    }

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    fetch(
      `${routes.predictive_search_url}?q=${encodeURIComponent(
        apiTerm
      )}&resources[type]=product,collection,page,query&resources[limit]=10&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,vendor,tag,variants.title&section_id=predictive-search`,
      { signal: this.abortController.signal }
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        if (searchTerm !== this.searchTerm) return;
        const parsedDoc = new DOMParser().parseFromString(text, 'text/html');
        const resultsMarkup = parsedDoc.querySelector('#shopify-section-predictive-search').innerHTML;

        // Relevance guard: Shopify's ML rewrites complete words (e.g. "winder" →
        // "singer", "bobbin winder" → "bobbin singer"), returning wrong products or
        // none at all. The prefix form ("winde", "bobbin winde") uses clean prefix
        // matching and returns the correct results. Fall back to the prefix whenever
        // products are missing or their titles don't contain the search term.
        // Custom QSV sections (stores, tools, comparison tools, fabric hub, nearest-
        // store) are injected by predictive-search.liquid for specific terms and have
        // no product list. They're authoritative for those terms — never fall back to a
        // prefix query, which would replace the curated block with unrelated noise.
        const dbg = parsedDoc.querySelector('#psc-dbg');
        const hasCustomSection = !!dbg && (
          dbg.dataset.isStore === 'true' || dbg.dataset.isTool === 'true' ||
          dbg.dataset.isCompare === 'true' || dbg.dataset.isFabric === 'true' ||
          dbg.dataset.isNearby === 'true' || dbg.dataset.isStoreLocation === 'true' ||
          dbg.dataset.isCurated === 'true' || dbg.dataset.isCreateroom === 'true'
        );
        const productList = parsedDoc.querySelector('#predictive-search-results-products-list');
        let shouldFallback = false;
        if (hasCustomSection) {
          shouldFallback = false;
        } else if (!productList) {
          shouldFallback = true; // No products section = Shopify returned nothing useful
        } else {
          const productTitles = productList.querySelectorAll('.predictive-search__item-heading');
          if (productTitles.length > 0) {
            const termLower = searchTerm.toLowerCase();
            const apiTermLower = apiTerm.toLowerCase();
            const termCompact = termLower.replace(/\s+/g, '');
            const anyMatch = Array.from(productTitles).some(function(el) {
              const t = el.textContent.toLowerCase();
              return t.includes(termLower) || t.includes(apiTermLower) || t.replace(/\s+/g, '').includes(termCompact);
            });
            if (!anyMatch) shouldFallback = true;
          }
        }
        if (shouldFallback) {
          const rawTerm = searchTerm.trim().toLowerCase();
          const rawKey = rawTerm.replace(/\s+/g, '-');

          // If normalization changed the query, try the raw un-normalized form first.
          // "pr680" → normalized "pr 680" fails → raw "pr680" prefix-matches PR680W ✓
          // "pr68" → normalized "pr 68" fails → raw "pr68" prefix-matches PR680W ✓
          if (apiTerm !== rawTerm) {
            if (this.cachedResults[rawKey]) {
              this.renderSearchResults(this.cachedResults[rawKey]);
              return;
            }
            fetch(
              `${routes.predictive_search_url}?q=${encodeURIComponent(rawTerm)}&resources[type]=product,collection,page,query&resources[limit]=10&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,vendor,tag,variants.title&section_id=predictive-search`
            ).then((r) => r.ok ? r.text() : null)
             .then((t) => {
               if (!t || searchTerm !== this.searchTerm) return;
               const markup = new DOMParser().parseFromString(t, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
               this.allPredictiveSearchInstances.forEach((inst) => { inst.cachedResults[rawKey] = markup; });
               this.renderSearchResults(markup);
             })
             .catch(() => {});
            return;
          }

          // If the query has spaces and looks like a model number fragment (only letters,
          // digits, spaces), try the compact space-removed form. "pr 680" → "pr680"
          // prefix-matches "pr680w"; "bobbin winder" has no digits so this is skipped.
          const compactTerm = rawTerm.replace(/\s+/g, '');
          if (rawTerm.includes(' ') && compactTerm !== rawTerm && /[a-z]/.test(compactTerm) && /[0-9]/.test(compactTerm) && /^[a-z0-9]+$/.test(compactTerm)) {
            if (this.cachedResults[compactTerm]) {
              this.renderSearchResults(this.cachedResults[compactTerm]);
              return;
            }
            fetch(
              `${routes.predictive_search_url}?q=${encodeURIComponent(compactTerm)}&resources[type]=product,collection,page,query&resources[limit]=10&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,vendor,tag,variants.title&section_id=predictive-search`
            ).then((r) => r.ok ? r.text() : null)
             .then((t) => {
               if (!t || searchTerm !== this.searchTerm) return;
               const markup = new DOMParser().parseFromString(t, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
               this.allPredictiveSearchInstances.forEach((inst) => { inst.cachedResults[compactTerm] = markup; });
               this.renderSearchResults(markup);
             })
             .catch(() => {});
            return;
          }

          // Normalization didn't change the query (e.g. "winder", "bobbin winder").
          // Fall back to the prefix form which uses clean prefix matching.
          const prefixKey = queryKey.slice(0, -1);
          if (prefixKey && this.cachedResults[prefixKey]) {
            this.renderSearchResults(this.cachedResults[prefixKey]);
            return;
          } else if (prefixKey) {
            const prefixSearchTerm = searchTerm.slice(0, -1);
            const prefixApiTerm = this.normalizeSearchTerm(prefixSearchTerm);
            fetch(
              `${routes.predictive_search_url}?q=${encodeURIComponent(prefixApiTerm)}&resources[type]=product,collection,page,query&resources[limit]=10&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,vendor,tag,variants.title&section_id=predictive-search`
            ).then((r) => r.ok ? r.text() : null)
             .then((t) => {
               if (!t || searchTerm !== this.searchTerm) return;
               const markup = new DOMParser().parseFromString(t, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
               this.allPredictiveSearchInstances.forEach((inst) => { inst.cachedResults[prefixKey] = markup; });
               this.renderSearchResults(markup);
             })
             .catch(() => {});
            return;
          }
        }

        // Save bandwidth keeping the cache in all instances synced
        this.allPredictiveSearchInstances.forEach(
          (predictiveSearchInstance) => {
            predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
          }
        );
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        if (error?.name === 'AbortError' || error?.code === 20) {
          return;
        }
        this.close();
        throw error;
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    if (this.statusElement) this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    if (!this.statusElement) return;
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      if (this.statusElement) this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    // Keep the "Search for …" label in sync with exactly what the user typed.
    // Relevance-guard fallbacks re-fetch a prefix/normalized query (e.g. the term
    // minus its last letter), and that markup's terms would otherwise show fewer
    // letters than the shopper typed. Swap only the quoted terms so it stays
    // locale-safe; if the quoted pattern isn't present, the label is left as-is.
    const typedTerm = this.getQuery();
    if (typedTerm) {
      const searchForTextEl = this.predictiveSearchResults.querySelector('[data-predictive-search-search-for-text]');
      if (searchForTextEl && /[“"][^”"]*[”"]/.test(searchForTextEl.textContent)) {
        searchForTextEl.textContent = searchForTextEl.textContent.replace(/[“"][^”"]*[”"]/, '“' + typedTerm + '”');
      }
    }
    this.promoteStorePages();
    this.promoteTitleMatches();
    this.setAttribute('results', true);

    this.setLiveRegionResults();
    this.open();
  }

  promoteTitleMatches() {
    // Keep exact name matches above fuzzy ones. Shopify predictive search will
    // sometimes rank an unrelated fuzzy match above the product literally named in
    // the query (e.g. the "Arrow Ava" cabinet matched "baby lock array" via fuzzy
    // matching and outranked the actual Baby Lock Array machine, especially right
    // after the machine was edited and briefly re-indexing). Reorder the product
    // list so any product whose title contains the typed query comes first,
    // preserving the relative order within each group.
    try {
      var q = (this.getQuery() || '').toLowerCase().replace(/\s+/g, '');
      if (q.length < 3) return;
      var list = this.predictiveSearchResults.querySelector('#predictive-search-results-products-list');
      if (!list) return;
      var items = Array.prototype.slice.call(list.children);
      if (items.length < 2) return;
      var matches = [], rest = [];
      items.forEach(function(li) {
        var h = li.querySelector('.predictive-search__item-heading');
        var t = h ? h.textContent.toLowerCase().replace(/\s+/g, '') : '';
        (t.indexOf(q) !== -1 ? matches : rest).push(li);
      });
      if (matches.length && rest.length) {
        matches.concat(rest).forEach(function(li) { list.appendChild(li); });
      }
    } catch (e) {}
  }

  promoteStorePages() {
    var q = (this.searchTerm || '').toLowerCase().trim();
    var isStore = q === 'store' || q === 'stores'
      || q.indexOf('store location') >= 0
      || q.indexOf('near me') >= 0
      || q.indexOf('store near') >= 0
      || q.indexOf('store hours') >= 0;
    if (!isStore) return;
    var wrapper = this.predictiveSearchResults.querySelector('#predictive-search-results-groups-wrapper');
    if (!wrapper) return;
    var firstGroup = wrapper.querySelector('.predictive-search__result-group');
    if (!firstGroup) return;
    var isMobile = window.innerWidth <= 749;
    if (isMobile) {
      // On mobile: lift the mobile pages wrapper to BEFORE the first result group in the
      // wrapper div. Inserting here (not inside either group) avoids the CSS rule that
      // hides .predictive-search__pages-wrapper when it's inside the first group.
      var mobileHeading = document.getElementById('predictive-search-pages-mobile');
      if (!mobileHeading) return;
      var pagesSection = mobileHeading.closest('.predictive-search__pages-wrapper');
      if (!pagesSection) return;
      wrapper.insertBefore(pagesSection, firstGroup);
    } else {
      // On desktop: move desktop pages to top of first group (left column)
      var desktopHeading = document.getElementById('predictive-search-pages-desktop');
      if (!desktopHeading) return;
      var desktopPages = desktopHeading.closest('.predictive-search__pages-wrapper');
      if (!desktopPages) return;
      firstGroup.insertBefore(desktopPages, firstGroup.firstElementChild);
    }
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    const countEl = this.querySelector('[data-predictive-search-live-region-count-value]');
    if (countEl) this.setLiveRegionText(countEl.textContent);
  }

  getResultsMaxHeight() {
    const header = document.querySelector('.section-header');
    const headerBottom = header ? header.getBoundingClientRect().bottom : 0;
    this.resultsMaxHeight = window.innerHeight - headerBottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false
    this.predictiveSearchResults.removeAttribute('style');
  }
}

customElements.define('predictive-search', PredictiveSearch);
